import moment from 'moment/moment'

export function formatDate(date, dateInput?: string, dateOutput?: string) {
    if (date) return moment(date, dateInput || '').format(dateOutput || 'DD-MM-YYYY')
    return ""

}
